<template>
  <div v-if="show" class="showbanner">
    <p class="text-right">
      <a @click="close" style="cursor:pointer;"><span class="glyphicon glyphicon-remove-circle"></span></a>
    </p>
    <h3><strong>{{banner.Type}}</strong></h3>
    <p>
      {{banner.Description}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      twoWay: true
    },
    banner: {
      type: Object
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
    close: function () {
      this.show = false
    }
  }
}
</script>

<style scoped>
  .showbanner {
    position: fixed;
    z-index: 99999;
    bottom: 2%;
    left: 2%;
    padding: 10px;
    text-align: left;
    color: rgb(51, 51, 51);
    font-size: 16px;
    width: 400px;
    max-width: 80%;
    box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 15px;
    transition: all 0.4s ease;
    background: rgba(242,222,222,0.95);
  }
</style>


// WEBPACK FOOTER //
// banner.vue?d70afb70